import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import { Button, Modal, Space, Table, Select, Input, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Createseller from "./components/Createseller";
import Editseller from "./components/Editseller";
import { deleteItem, readUsers, readRoles, readItems, deleteUser } from "@directus/sdk";
import { useSelector } from "react-redux";
import validarpermiso from "../../lib/utils";
import { ObtenerUsuarios, ObtenerUsuariosCount, ObtenerUsuariosPorSuperior } from "../../services/usuarios";

const { Option } = Select;

const Sellers = (props) => {
  const [datasellers, setDatasellers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [opencreate, setOpencreate] = useState(false);
  const [openupdate, setOpenupdate] = useState(false);
  const [selectseller, setSelectseller] = useState({});
  const [bodegas, setBodegas] = useState([]);
  const [selectedBodega, setSelectedBodega] = useState(null);
  const [nameFilter, setNameFilter] = useState("");
  const [hasPermissionError, setHasPermissionError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [superiores, setSuperiores] = useState([]);
  const [selectedSuperior, setSelectedSuperior] = useState(null);
  const permisos = useSelector((state) => state.permisos);
  const userRoleID = useSelector((state) => state.userdata.role?.name);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userId = useSelector((state) => state.userdata.id);
  const columns = [
    {
      title: "Name",
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Correo",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Rol",
      dataIndex: "role.name",
      key: "role.name",
      render: (_, record) => {
        return record.role.name;
      },
    },
    {
      title: "Documento",
      dataIndex: "documento",
      key: "documento",
    },
    {
      title: "Bodega",
      dataIndex: "bodega.nombre",
      key: "bodega.nombre",
      render: (_, record) => {
        return record.bodega ? record.bodega.nombre : "Sin bodega";
      },
    },
    {
      title: "Acciones",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {validarpermiso("directus_users", "delete", permisos) && (
            <Button
              onClick={async () => {
                const directus = await getDirectusClient();
                Modal.confirm({
                  title: "Eliminar usuario",
                  icon: <ExclamationCircleFilled />,
                  content: "¿Desea eliminar este usuario?",
                  onOk() {
                    directus
                      .request(deleteUser( record.id))
                      .then(() => getSellers());
                  },
                });
              }}
            >
              Eliminar
            </Button>
          )}
          {validarpermiso("directus_users", "update", permisos) && (
            <Button
              onClick={() => {
                setSelectseller(record);
                setOpenupdate(true);
              }}
            >
              Editar
            </Button>
          )}
        </Space>
      ),
    },
  ];

  const getRoles = async () => {
    const directus = await getDirectusClient();
    directus
      .request(
        readRoles({
          fields: ["id", "name", "vende"],
          filter: {
            name: {
              _neq: "clientes",
            },
          },
        })
      )
      .then((res) => {
        setRoles(res);
      })
      .catch((err) => console.log(err));
  };

  const getBodegas = async () => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readItems("bodegas", {
          fields: ["id", "nombre"],
          filter: {
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  id: { _eq: userBodega },
                }
              : {}),
          },
          sort: ["nombre"],
        })
      );
      setBodegas(response);
    } catch (err) {
      console.error("Error fetching bodegas:", err);
    }
  };

  const getSuperiores = async () => {
    try {
      const response = await ObtenerUsuarios(
        {},
        userRoleID,
        userBodega
      );
      setSuperiores(response);
    } catch (error) {
      console.error("Error fetching superiores:", error);
    }
  };

  const getSellers = async (page = 1, pageSize = 10) => {
    if (!validarpermiso("directus_users", "read", permisos)) {
      setHasPermissionError(true);
      return;
    }

    setLoading(true);
    try {
      let users;
      let countResponse;

      if (selectedSuperior) {
        // Si hay un superior seleccionado, obtener los usuarios que tienen ese superior
        [users, countResponse] = await Promise.all([
          ObtenerUsuariosPorSuperior(selectedSuperior, pageSize, page),
          ObtenerUsuariosCount(
            {
              _and: [
                { superior: { id: { _eq: selectedSuperior } } },
                selectedRole ? { role: { id: { _eq: selectedRole } } } : {},
                selectedBodega ? { bodega: { id: { _eq: selectedBodega } } } : {},
                nameFilter
                  ? {
                      _or: [
                        { first_name: { _icontains: nameFilter } },
                        { last_name: { _icontains: nameFilter } },
                      ],
                    }
                  : {},
              ],
            },
            userRoleID,
            userBodega
          ),
        ]);
      } else {
        // Si no hay superior seleccionado, obtener todos los usuarios
        const filters = {
          _and: [
            selectedRole ? { role: { id: { _eq: selectedRole } } } : {},
            selectedBodega ? { bodega: { id: { _eq: selectedBodega } } } : {},
            nameFilter
              ? {
                  _or: [
                    { first_name: { _icontains: nameFilter } },
                    { last_name: { _icontains: nameFilter } },
                  ],
                }
              : {},
          ],
        };

        [users, countResponse] = await Promise.all([
          ObtenerUsuarios(filters, userRoleID, userBodega, pageSize, page),
          ObtenerUsuariosCount(filters, userRoleID, userBodega, pageSize, page),
        ]);
      }

      const total = parseInt(countResponse[0]?.countDistinct?.id || 0);
      setDatasellers(users.filter((user) => user.role.name !== "clientes"));
      setPagination(prev => ({
        ...prev,
        current: page,
        pageSize,
        total,
      }));
      setHasPermissionError(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      if (error.response?.status === 403 || error.message?.includes("permission")) {
        setHasPermissionError(true);
        message.error("No tiene permisos para ver los usuarios");
      } else {
        Modal.error({
          title: "Error",
          content: "Error al obtener los usuarios",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRoles();
    getBodegas();
    getSuperiores();
    getSellers();
  }, []);

  useEffect(() => {
    getSellers(pagination.current, pagination.pageSize);
  }, [selectedRole, selectedBodega, selectedSuperior, nameFilter]);

  const handleTableChange = (pagination) => {
    getSellers(pagination.current, pagination.pageSize);
  };

  const closeCreate = () => {
    setOpencreate(false);
  };

  const closeUpdate = () => {
    setOpenupdate(false);
  };

  return (
    <Layouts>
      {!hasPermissionError ? (
        <>
          <Space
            direction="vertical"
            style={{ width: "100%", marginBottom: 16 }}
          >
            <Space>
              {validarpermiso("directus_users", "create", permisos) && (
                <Button
                  onClick={() => setOpencreate(true)}
                  disabled={hasPermissionError}
                >
                  Crear usuario
                </Button>
              )}
              <Input.Search
                placeholder="Buscar por nombre"
                style={{ width: 200 }}
                onSearch={(value) => setNameFilter(value)}
                allowClear
                disabled={hasPermissionError}
              />
              <Select
                style={{ width: 200 }}
                placeholder="Filtrar por rol"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) => setSelectedRole(value)}
                disabled={hasPermissionError}
              >
                <Option value={null}>Todos los roles</Option>
                {roles.map((role) => (
                  <Option key={role.id} value={role.id}>
                    {role.name}
                  </Option>
                ))}
              </Select>
              <Select
                style={{ width: 200 }}
                placeholder="Filtrar por bodega"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                }
                onChange={(value) => setSelectedBodega(value)}
                disabled={hasPermissionError}
              >
                <Option value={null}>Todas las bodegas</Option>
                {bodegas.map((bodega) => (
                  <Option key={bodega.id} value={bodega.id}>
                    {bodega.nombre}
                  </Option>
                ))}
              </Select>
              <Select
                style={{ width: 200 }}
                placeholder="Filtrar por superior"
                allowClear
                showSearch
                filterOption={false}
                onSearch={(value) => {
                  if (value) {
                    const filteredUsers = superiores.filter(user => 
                      `${user.first_name} ${user.last_name}`.toLowerCase().includes(value.toLowerCase())
                    );
                    setSuperiores(filteredUsers);
                  } else {
                    getSuperiores();
                  }
                }}
                onChange={(value) => setSelectedSuperior(value)}
                disabled={hasPermissionError}
              >
                <Option value={null}>Todos los superiores</Option>
                {superiores.map((superior) => (
                  <Option key={superior.id} value={superior.id}>
                    {superior.first_name} {superior.last_name}
                  </Option>
                ))}
              </Select>
            </Space>
          </Space>

          <Table 
            columns={columns} 
            dataSource={datasellers} 
            rowKey="id" 
            loading={loading}
            pagination={{
              ...pagination,
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50"],
            }}
            onChange={handleTableChange}
          />

          {validarpermiso("directus_users", "create", permisos) && (
            <Createseller
              getSellers={getSellers}
              opencreate={opencreate}
              closeCreate={closeCreate}
              permisos={permisos}
            />
          )}

          {openupdate &&
            selectseller &&
            validarpermiso("directus_users", "update", permisos) && (
              <Editseller
                getSellers={getSellers}
                opencreate={openupdate}
                closeUpdate={closeUpdate}
                selectseller={selectseller}
                setSelectseller={setSelectseller}
                permisos={permisos}
              />
            )}
        </>
      ) : (
        <h3>No tiene permisos para ver usuarios</h3>
      )}
    </Layouts>
  );
};

export default Sellers;
